import { SparePart } from '@ecs-features/result/spare-parts-result/spare-parts.interface';

export type CrossSellingCableResponse = CrossSellingCableSteps[];

export interface CrossSellingCableSteps {
    sparePartId: string;
    steps?: CrossSellingCableStep[];
}

export interface CrossSellingCableStep {
    min: number;
    max: number;
    size: number;
}

export type SparePartWithCableSteps = SparePart & {
    cableSteps: number[];
    currentCableStepIndex: number;
    currentCableValue: number;
    cableError: boolean;
    cableErrorType?: CableErrorType;
    cableErrorMessageKey?: string;
    noCableDataAvailable: boolean;
};

export enum CableErrorType {
    MINIMUM_EXCEEDED,
    MAXIMUM_EXCEEDED,
    UNAUTHORIZED_INTERMEDIATED_VALUE,
}

export type SparePartsWithCableSteps = SparePartWithCableSteps[];
